import { Box, Grid, InputLabel, FormControlLabel, Switch } from '@mui/material';

interface SwitchComponentProps {
  values: any;
  index: number;
  childIndex: number;
  setFieldValue: (key: string, value: any) => void;
  onSubmit: (data: any) => void;
  handleChange: (e: any) => void;
  handleBlur: (e: any) => void;
}

export default function SwitchComponent({
  values,
  index,
  childIndex,
  setFieldValue,
  onSubmit,
  handleChange,
  handleBlur
}: SwitchComponentProps) {
  const child = values.fields[index].children[childIndex];

  return (
    <Box sx={{ width: '100%' }}>
      <Grid container alignItems="center" spacing={1}>
        <Grid item xs={10}>
          <InputLabel sx={{ color: 'black' }}>{child.question}</InputLabel>
        </Grid>
        <Grid item xs={2}>
          <FormControlLabel
            control={
              <Switch
                checked={!!child.answer}
                onChange={(_, checked) => setFieldValue(`fields.${index}.children.${childIndex}.answer`, checked)}
                name={`fields.${index}.children.${childIndex}.answer`}
                color="primary"
              />
            }
            label={child.description || ''}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
